module.exports = __webpack_public_path__ + "static/kf-left-image-9afa46f44f629f4f423037344b57f4ee.png";